import React, { useState } from 'react';

import Image from '../Image';

interface ImageWithFallbackProps {
  className?: string;
  src: string;
  alt: string;
  width: number;
  height: number;
  fallBack: React.ReactNode;
  onError?: () => void;
  minWidth?: number;
  minHeight?: number;
  aspectRatio?: number;
  blurHash?: string;
  transformations?: Record<string, unknown>;
  lazy?: boolean;
  fitWidth?: boolean;
  onClick?: () => void;
  trackingData?: Record<string, unknown>;
  attribution?: Record<string, unknown>;
  attributionClassName?: string;
}

const ImageWithFallback = ({ src, alt, width, height, fallBack, onError, ...props }: ImageWithFallbackProps) => {
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);

    if (onError) {
      onError?.();
    }
  };

  if (hasError || !src) {
    return fallBack;
  }

  return (
    <Image
      className={props.className}
      src={src}
      alt={alt}
      width={width}
      height={height}
      minWidth={props.minWidth}
      minHeight={props.minHeight}
      aspectRatio={props.aspectRatio}
      blurHash={props.blurHash}
      transformations={props.transformations}
      lazy={props.lazy}
      fitWidth={props.fitWidth}
      onClick={props.onClick}
      trackingData={props.trackingData}
      attribution={props.attribution}
      attributionClassName={props.attributionClassName}
      onError={handleError}
      {...props}
    />
  );
};

export default ImageWithFallback;
